export default "/build/static/fonts/Whitney-Black_Web.woff";